<template>
  <div id="genericErrorModal" class="modal fade" role="dialog" tabindex="-1">
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <div>
          <img
              :src="require(`.././../../assets/images/error@2x.jpg`)"
              :srcset="`${require(`../../../assets/images/error@1x.jpg`)} 1x, ${require(`../../../assets/images/error@2x.jpg`)} 2x, ${require(`../../../assets/images/error@3x.jpg`)} 3x, ${require(`../../../assets/images/error@4x.jpg`)} 4x`"
          />

          <div class="modal-body">
            <h2>{{ 'Oops, Something Went Wrong' | trans }}</h2>
            <p>{{ 'It looks like there was an issue. We dispatched our seal team to solve this issue.' | trans }}</p>
            <p>
              <strong>{{ 'Please try again later.' | trans  }}</strong>
            </p>
          </div>
        </div>

        <div class="modal-footer">
          <button class="btn close-btn" @click.prevent="close">
            <i class="fa fa-times mr-1"></i><strong>{{ 'Cancel' | trans }}</strong>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import store from './../../../mixins/store.mixin';
import { EventBus } from './../../../events/event.bus';
import {APP_GENERIC_ERROR} from "../../../events/app.events";
import user from "../../../mixins/user.mixin";

export default {
  name: 'GenericErrorModal',
  props: {},
  components: {  },
  mixins: [store, user],
  data() {
    return {};
  },
  mounted: function () {
    $('#genericErrorModal').modal({ show: false });
  },
  created: function () {
    EventBus.$on(APP_GENERIC_ERROR, (data) => {
      if (this.isFreeUser) {
        $('#genericErrorModal').modal('show');
      }
    });
  },
  methods: {
    close() {
      $('#genericErrorModal').modal('hide');
    },
  },
  computed: {},
};
</script>
<style lang="scss">
#genericErrorModal {
  img {
    width: 100%;
  }

  .modal-dialog {
    width: 599px;
    max-width: 95%;
    border-radius: 9px;
    overflow: hidden;
  }

  .close-btn {
    background: #d9d9d9;
    height: 38px;
    gap: 10px;
    padding: 0 10px 0 10px;
    font-weight: 600;
  }

  .premium-btn {
    background-color: #ffaa00;
    height: 38px;
    gap: 10px;
    display: flex;
    align-items: center;
    font-weight: 600;
    padding: 0 10px 0 10px;
  }

  .modal-content-title {
    font-size: 28px;
    font-weight: 600;
  }

  .modal-content {
    h2 {
      margin-top: 0;
    }

    font-size: 17.5px;
    border: 1px solid #ccc;

    p {
      font-size: 17.5px;
    }
  }

  .modal-body {
    padding: 20px;
  }

  .modal-footer {
    display: flex;
    padding: 10px 10px;
    justify-content: flex-end;
    align-items: center;
    gap: 10px;
    align-self: stretch;
    background: #f8f9fa;

    .btn {
      margin: 0;
    }
  }
}
</style>
